module.exports = __webpack_public_path__ + "e748b6e3612d930fba0afefea57eb576.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/globe_logo.png
// module id = 403
// module chunks = 0